import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { Loader } from '../../../../common/components';

const ListTeamMemberPage = loadable(() => import('./ListTeamMemberPage'), {
  fallback: <Loader />
});

const TeamMemberRoutes = ({ t, setTabLoading , alert }) => {
  return (
    <Route
      key="team_list"
      exact
      path="/view/:projectId/team"
      element={<ListTeamMemberPage t={t} setTabLoading={setTabLoading} alert={alert} />}
    />
  );
};
TeamMemberRoutes.propTypes = {
  t: PropTypes.func
};
export default TeamMemberRoutes;
